/**
 * 系统-角色管理
 * 新建 / 编辑弹窗：formItems + `CResourcePermTree` 资源勾选树
 */
import { roleEditDialog, roleTypeLabel } from './_dialogs'
import { UI_PAGE_EVENTS } from '@zto/zpage-ui-element'


export default {
  body: {
    type: 'crud',
    actions: {
      query: {
        api: '/base_user/admin/role/list',
      },
      add: {
        label: '新建',
        api: '/base_user/admin/role/create',
        dialog: roleEditDialog(false),
        successMessage: '创建成功'
      },
      edit: {
        label: '编辑',
        api: '/base_user/admin/role/update',
        dialog: roleEditDialog(true),
        successMessage: '保存成功'
      },
      delete: {
        label: '删除',
        api: '/base_user/admin/role/delete',
        payload: {
          id: '${data.row.id}'
        },
        message: '确认删除该角色？已分配该角色的账号将受影响。'
      }
    },
    searchOn: [UI_PAGE_EVENTS.ACTIVATED],
    search: {
      labelWidth: 100,
      items: [{ type: 'input', prop: 'roleName', label: '角色名称', span: 8 }]
    },
    toolbar: {
      noExport: true,
      items: [{ action: 'add' }]
    },
    table: {
      operation: {
        width: 140,
        items: [{ action: 'edit' }, { action: 'delete' }]
      },
      columns: [
        { label: '角色名称', prop: 'roleName', minWidth: 160 },
        {
          label: '角色类型',
          prop: 'roleType',
          minWidth: 140,
          formatter: roleTypeLabel
        }
      ]
    }
  }
}
